import FullLayout from "./../layouts/fullLayout";
import BlankLayout from "./../layouts/blankLayout";

var indexRoutes = [
  { path: "/pages", name: "System Misc. Pages", component: BlankLayout },
  { path: "/", name: "Home", component: FullLayout }
];

export default indexRoutes;
